import { render, staticRenderFns } from "./ModuleBase.vue?vue&type=template&id=3625c559&"
import script from "./ModuleBase.vue?vue&type=script&lang=js&"
export * from "./ModuleBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports